import { useContext, useEffect, useState } from 'react';
import './App.css';
import { AuthContext } from './Contexts/AuthContext';
import { Loader } from "./Component/Loader/Loader";
import { Navbar } from "./Component/Navbar/Navbar";
import { Route, Routes } from 'react-router-dom';
import { Home } from './Component/Home/Home';
import { Bounce, ToastContainer } from 'react-toastify';
import { Products } from './Component/Products/Products';
import { ProductView } from './Component/Product View/ProductView';
import { Login } from './Component/Login/Login';
import { Signup } from './Component/Signup/Signup';
import { RequiresAuth } from './Component/Auth/RequiresAuth';
import { Wishlist } from './Component/Wishlist/Wishlist';
import { UserDetails } from './Component/UserDetails/UserDetails';
import { Cart } from './Component/Cart/Cart';
import SnpChatApp, { useSnpChatPublicApi } from './Component/Chatengine/SnpChatApp';
import { printDebugLog } from './Utils/utils';
import { WEBSITE_SHOP_HASH } from './Utils/constant';
import PaymentPage from './Component/Payment/PaymentPage';
import JsonLoader from './Component/JsonLoader/JsonLoader';

function App() {
  const { loader } = useContext(AuthContext);

  const [showChat, setShowChat] = useState(true);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

      const ctrlKey = isMac ? e.metaKey : e.ctrlKey;

      if (ctrlKey && e.altKey && e.key === '3') {
        e.preventDefault();
        setShowChat(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);


  return (
    <div className="App">
      {loader && <Loader />}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/view/products" element={<ProductView />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/pay-verify" element={<PaymentPage />} />
        <Route path="/terms-and-condition" element={<JsonLoader />} />
        <Route path="/shipping-policy" element={<JsonLoader />} />
        <Route path="/cancellation-policy" element={<JsonLoader />} />
        <Route path="/privacy-policy" element={<JsonLoader />} />
        <Route
          path="/wishlist"
          element={
            <RequiresAuth>
              <Wishlist />
            </RequiresAuth>
          }
        />
        <Route
          path="/userDetails"
          element={
            <RequiresAuth>
              <UserDetails />
            </RequiresAuth>
          }
        />
        <Route
          path="/cart"
          element={
            <RequiresAuth>
              <Cart />
            </RequiresAuth>
          }
        />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable
        pauseOnHover={true}
        theme="dark"
        transition={Bounce}
      />
      <SnpChatApp onAdminMounted={() => {
        printDebugLog("SnpChatApp:onAdminMounted");
        useSnpChatPublicApi.registerChatKey(WEBSITE_SHOP_HASH);
      }} />

    </div>
  );
}

export default App;
